import { Theme } from '@mui/material';
import { SxProps } from '@mui/system';

const styles = {
  container: {
    mt: '10px',
  },
  serviceContainer: {
    pt: '15px',
  },
  buttonContainer: {
    paddingTop: '16px',
  },
  button: {
    backgroundColor: 'common.lightGreen',
    color: 'primary.main',
  },
  padTop: { pt: '15px' },
  counterOfferBtn: {
    backgroundColor: 'common.lightGreen',
    border: 'none',
  },

  counterOfferContainer: {
    mt: '16px',
    mb: '6px',
  },

  promoText: {
    fontSize: 13,
    fontWeight: '500',
    color: 'primary.main',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
